export default __webpack_public_path__ + "static/title-pc-e89558258da71fb97b6b49a8ab55432f.png";